<template lang="pug">
.table.w-full
    vue-table-dynamic(:params="params" ref="table")
</template>

<script>
    import VueTableDynamic from 'vue-table-dynamic'

const random = () => {
  return parseInt(Date.now() + Math.random() * 10000000).toString(16).slice(-6)
}

export default {
    name: 'TableComponents',
    data() {
        return {
            params: {
                data: [
                    ['no.', `Data1`, `Data2`, `Data3`, `Data4`, `Data5`, `Data6` ]
                ],
                header: 'row',
                border: false,
                stripe: true,
                // enableSearch: true,
                enableSearch: false,
                // showCheck: true,
                columnWidth: [
                    {
                        column: 0,
                        width: 40,
                    },
                ],
                fixed: 0,
                pagination: true,
                pageSize: 2,
            },
        }
    },
    mounted () {
        for (let i = 0; i < 50; i++) {
            this.params.data.push([i+1, `${random()}`, `${random()}`, `${random()}`,  `${random()}`, `${random()}`, `${random()}`])
        }
    },
    components: {
        VueTableDynamic,
    },
}
</script>

<style lang="sass">
.table
    .v-table
        border: 1px solid #e8eef5
        border-bottom: none
    .table-check-all
        margin: 0px
    .table-cell
        padding: 8px
    .v-table-row
        padding: 8px 0px
        border-bottom: 1px solid #e8eef5
        height: auto !important
        &.is-striped
            background-color: rgba(232, 238, 245, 0.3)
        &.is-hovering
            background-color: rgba(232, 238, 245, 0.8)
</style>
